import { createContext } from "react";

const PlayerInfoContext = createContext();
export default PlayerInfoContext;